import { render } from "./SurveyPage08.vue?vue&type=template&id=1d589070&scoped=true"
const script = {}

import "./SurveyPage08.vue?vue&type=style&index=0&id=1d589070&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d589070"]])

export default __exports__